export default {
  root: {
    fontSize: '1.5rem',
    lineHeight: 1.5,
    padding: '0 20px',
  },
};
